module.exports = __webpack_public_path__ + "05ed2258255ff47bd1e5cffb2d368576.pdf";